'use client'

import { getReturnReceipt } from '@/lib/actions/order/get-return-receipt'
import { getPrinterType } from '@/lib/actions/register/get-printer-type'
import { useModals, useSearchParams } from '@/lib/hooks'
import { Loader2 } from 'lucide-react'
import React from 'react'

import { PrintReturnReceipt } from '@/components/molecules'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui'

interface PrintReturnReceiptModalProps
  extends React.ComponentPropsWithoutRef<'div'> {
  open?: boolean
}

export const PrintReturnReceiptModal = ({
  open,
}: PrintReturnReceiptModalProps) => {
  const { closeModal } = useModals()
  const [isPending, startTransition] = React.useTransition()
  const [printerType, setPrinterType] = React.useState<string | null>('thermal')
  const [receipt, setReceipt] = React.useState<any>(null)
  const { orderReturnId } = useSearchParams()

  React.useEffect(() => {
    if (!orderReturnId) return

    startTransition(async () => {
      const getPrinter = await getPrinterType()
      const receipt = await getReturnReceipt(orderReturnId)
      setPrinterType(getPrinter?.printerType ?? null)
      setReceipt(receipt)
    })
  }, [orderReturnId])

  return (
    <Dialog
      open={open}
      onOpenChange={(isOpen) => {
        if (!isOpen) {
          closeModal('PRINT_RETURN_RECEIPT')
        }
      }}
    >
      <DialogContent
        closeOnOverlay
        onClose={() => closeModal('PRINT_RETURN_RECEIPT')}
        size="lg"
        className="min-h-[410px] gap-4"
      >
        <DialogHeader>
          <DialogTitle>
            <div className="flex items-center gap-2">Return Receipt</div>
          </DialogTitle>
          <DialogDescription className="text-left">
            Receipt for Return ID #{orderReturnId}
          </DialogDescription>
        </DialogHeader>

        {isPending && (
          <div className="flex w-full items-center justify-center">
            <Loader2 className="animate-spin text-gray-300" />
          </div>
        )}

        {orderReturnId && !isPending && (
          <PrintReturnReceipt
            printerType={printerType}
            receipt={receipt}
            orderReturnId={orderReturnId}
          />
        )}
      </DialogContent>
    </Dialog>
  )
}

